import { TextElement } from "./TextElement";
import { getValueOrDefault } from "../../core/utilities/extensions";
import { PositionType } from "common/constants";
import * as geom from "../../core/utilities/geom";

export class PositionableTextElement extends TextElement {
    get selectionPadding() {
        return 0;
    }

    get canDragResize() {
        return true;
    }

    get textPosition() {
        if (this.canPosition) {
            return getValueOrDefault(this.model.textPosition, PositionType.CENTER);
        } else {
            return PositionType.CENTER;
        }
    }

    get textStyle() {
        if (this.canStyle) {
            return getValueOrDefault(this.model.textStyle, null);
        } else {
            return null;
        }
    }

    get canPosition() {
        return getValueOrDefault(this.options.canPosition, true);
    }

    get canStyle() {
        return getValueOrDefault(this.options.canStyle, true);
    }

    _loadStyles(styles) {
        switch (this.textStyle) {
            case "white_box":
                styles.decoration = {
                    type: "frame",
                    shape: "rect",
                    fillColor: "white"
                };
                break;
            case "transparent_light_box":
                styles.decoration = {
                    type: "frame",
                    shape: "rect",
                    fillColor: "white",
                    fillOpacity: 0.5
                };
                break;
            case "transparent_dark_box":
                styles.decoration = {
                    type: "frame",
                    shape: "rect",
                    fillColor: "black",
                    fillOpacity: 0.3
                };
                break;
            case "white_text":
                styles.fontColor = "white";
                break;
            case "dark_text":
                styles.fontColor = "primary_dark";
                break;
            case "white_text_with_shadow":
                styles.fontColor = "white";
                styles.filter = "textShadow";
                break;
        }
    }
}

